module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Podstawowe dane")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Twoja nazwa tego konta",
      "name": "name",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.item.name = $$v
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Adres e-mail z jakiego będą wychodzić wiadomości",
      "name": "from_address",
      "type": "text",
      "validation-rules": "required|email",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Adres e-mail z jakiego będą wychodzić wiadomości"
    },
    model: {
      value: (_vm.item.from_address),
      callback: function($$v) {
        _vm.item.from_address = $$v
      },
      expression: "item.from_address"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Nazwa wysyłającego wiadomości",
      "name": "from_name",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Nazwa wysyłającego wiadomości"
    },
    model: {
      value: (_vm.item.from_name),
      callback: function($$v) {
        _vm.item.from_name = $$v
      },
      expression: "item.from_name"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Dane konta smtp")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Serwer",
      "name": "host",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę serwera np. mail.twoja-domena.com"
    },
    model: {
      value: (_vm.item.host),
      callback: function($$v) {
        _vm.item.host = $$v
      },
      expression: "item.host"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Port",
      "name": "port",
      "type": "number",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę serwera np.: mail.twoja-domena.com"
    },
    model: {
      value: (_vm.item.port),
      callback: function($$v) {
        _vm.item.port = $$v
      },
      expression: "item.port"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Nazwa użytkownika",
      "name": "username",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę użytkownika np. user@mail.twoja-domena.com"
    },
    model: {
      value: (_vm.item.username),
      callback: function($$v) {
        _vm.item.username = $$v
      },
      expression: "item.username"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Hasło użytkownika",
      "name": "password",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz hasło użytkownika"
    },
    model: {
      value: (_vm.item.password),
      callback: function($$v) {
        _vm.item.password = $$v
      },
      expression: "item.password"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Szyfrowanie",
      "name": "encryption",
      "type": "text",
      "placeholder": "Wpisz szyfrowanie np.: tls",
      "help-text": "Zostaw pole puste lub wpisz tls"
    },
    model: {
      value: (_vm.item.encryption),
      callback: function($$v) {
        _vm.item.encryption = $$v
      },
      expression: "item.encryption"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Limit wysyłania")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Limit wysyłanych wiadomości za jednym razem",
      "name": "limit",
      "type": "number",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz limit wysyłanych wiadomości np.: 100",
      "help-text": "Warto ustawić tą wartość na małą liczbę np. 100 i zwiększać gdy nie ma żadnych kłopotów"
    },
    model: {
      value: (_vm.item.limit),
      callback: function($$v) {
        _vm.item.limit = $$v
      },
      expression: "item.limit"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72352b41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/Form.vue
// module id = 272
// module chunks = 0